import _ from 'underscore'
import axios from 'axios'
import store from '../state/store'

// Only the newest search's response is shown, so a slower message-text search can't overwrite a newer one.
let latestSearch = 0

store.on('search', function(search = '', options = {}) {
  const parsed_search = (search || '').trim()
  const searchId = ++latestSearch

  if (parsed_search.length < 3) {
    store.get().search.set({results: [], loading: false})
    return
  }

  store.get().search.set({loading: true})

  // WhatsApp/email message text is only searched when ticked.
  const params = {
    q: parsed_search,
    search_whatsapp_content: !!options.searchWhatsappContent,
    search_email_content: !!options.searchEmailContent
  }

  axios.get("/api/sales/searches", {params: params})
  .then(function(response) {
    if (searchId === latestSearch) {
      store.get().search.set({results: response.data.results})
    }
  })
  .catch(function(error) {
    handleError(error)
  })
  .then(function() {
    if (searchId === latestSearch) {
      store.get().search.set({loading: false})
    }
  })
})